import { HighlightOff } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { greyMui } from "@ryde/theme";

export interface IPreviewStepAdornment {
  isPreview?: boolean;
  isLoading?: boolean;
  onRefresh: () => void;
  onAbort: () => void;
}

export const PreviewStepAdornment: FC<IPreviewStepAdornment> = ({
  isLoading,
  onRefresh,
  isPreview,
  onAbort,
}) => {
  if (isLoading) {
    return (
      <IconButton onClick={onAbort} size="small">
        <HighlightOff color="error" sx={{ width: 16, height: 16 }} />
      </IconButton>
    );
  }

  return isPreview ? (
    <IconButton size="small" onClick={() => onRefresh()}>
      <SVG_MUI.ArrowsRotate3SVG color={greyMui.A700} />
    </IconButton>
  ) : null;
};
